import { createFileRoute } from "@tanstack/react-router";
import { LegalLayout } from "@/components/LegalLayout";
import { openCookiePreferences } from "@/lib/cookie-consent";

export const Route = createFileRoute("/legal/cookies")({
  head: () => ({
    meta: [
      { title: "Cookie Policy — The Hospitality Reserve" },
      {
        name: "description",
        content:
          "How The Hospitality Reserve uses cookies and similar technologies, the categories in use, and how to manage your preferences.",
      },
      { property: "og:title", content: "Cookie Policy — The Hospitality Reserve" },
      { property: "og:url", content: "https://thehospitalityreserve.com/legal/cookies" },
    ],
    links: [{ rel: "canonical", href: "https://thehospitalityreserve.com/legal/cookies" }],
  }),
  component: CookiesPage,
});

function CookiesPage() {
  return (
    <LegalLayout eyebrow="Legal" title="Cookie Policy" updated="18 June 2026">
      <p>
        We use cookies and similar storage technologies to operate the
        Platform, keep you signed in, secure the service, and (with your
        consent) measure usage.
      </p>

      <h2>Categories we use</h2>
      <ul>
        <li>
          <strong>Strictly necessary</strong> — authentication, session,
          security, load balancing, and CSRF protection. These cannot be
          disabled and do not require consent under PECR.
        </li>
        <li>
          <strong>Functional</strong> — remembering preferences such as
          notifications and display settings.
        </li>
        <li>
          <strong>Analytics</strong> — aggregated usage statistics to improve
          the Platform. Set only with consent via our cookie banner.
        </li>
      </ul>

      <h2>Managing cookies</h2>
      <p>
        You can update your consent at any time. Your choices are stored under
        the <code>reserve.cookie-consent</code> key in your browser and apply
        across sessions on this device. Most browsers also let you block or
        delete cookies through their settings.
      </p>
      <p>
        <button
          type="button"
          onClick={openCookiePreferences}
          className="inline-flex items-center border border-foreground px-5 py-2 text-[10px] tracking-wide-luxury text-foreground transition-colors hover:bg-foreground hover:text-background"
        >
          Manage cookie preferences
        </button>
      </p>

      <h2>Third parties</h2>
      <p>
        Our payment, identity verification, and email providers may set their
        own cookies when their flows are loaded (for example during checkout
        or ID verification). Please consult their respective policies.
      </p>
    </LegalLayout>
  );
}
